import loadable from '@loadable/component';
import ApplicationLayout from 'Components/ApplicationLayout';
import Loading from 'Components/Loading';
import pMinDelay from 'p-min-delay';
import PropTypes from 'prop-types';
import React from 'react';
import { useLocation } from 'react-router-dom';

const Help = loadable(() => pMinDelay(import('./Help'), 300), {
  fallback: <Loading />
});


const AsyncHelp = props => {
  const location = useLocation();
  const pathname = location.pathname;
  const pathSegments = pathname.split('/');
  const desiredPart = pathSegments[2];

  const pageConfig = {
    headerType: desiredPart === 'yardim-konulari' && (props.userAgent.device?.type === 'mobile') ? 'mobile-none' : 'full',
    footerType: props.userAgent.device?.type === 'desktop' ? 'full' : 'mobile-none',
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent.device?.type } bg-white hide-betslip hide-sticky-navigation`
      },
      link: [
        {
          rel: 'stylesheet',
          type: 'text/css',
          href: '/public/thirdParty/antd/antd.min.css'
        }
      ]
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <Help { ...props } helmet={ pageConfig.helmet } />
    </ApplicationLayout>
  );
};

AsyncHelp.propTypes = {
  userAgent: PropTypes.object
};

export default AsyncHelp;
